import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';
import logo from "../../images/KlickExLogo_w.png";

class DefaulNavbar extends Component {
    render() {
        return (
           
                    <div className='container p-0'>
                        <nav className=" navbar navbar-expand-sm bg-trans navbar-dark p-0 " style={{backgroundColor : 'transparent'}} >
                            <Link to="/" className="navbar-brand" href="#"><img src={logo} alt='' style={{ width: "80% " }} /></Link>
                        </nav>
                    </div>
          
        );
    }
}

export default DefaulNavbar;


// WEBPACK FOOTER //
// ./src/components/navigation/defaultnavbar.jsx